import { styled } from '@mui/material/styles';
import { Drawer } from 'core/common/ui/ui-kit';

export const DrawerStyled = styled(Drawer)`
  & .MuiPaper-root {
    background-color: ${({ theme }) => theme.palette.payment.drawer};
  }
`;
